<div class="progress">
  <div class="bar" [ngStyle]="{ 'width.%': progress * 100 }"></div>
</div>
